import { Tag } from "antd"
import { ArchiveSvg } from "assets/svg/icon"

interface Props {
  isArchived: boolean
  style?: React.CSSProperties
}

export function ArchivedLabel(props: Props) {
  const {
    isArchived,
    style
  } = props
  if (!isArchived) return null

  return (
    <Tag
      color="#eee"
      style={{
        display: 'flex',
        gap: '5px',
        justifyItems: 'center',
        alignItems: 'center',
        paddingTop: '4px',
        marginRight: '8px',
        flexShrink: 0,
        color: "#B9B9C4",
        ...style,
      }}>
      <ArchiveSvg />
      <span
        style={{
          color: '#888',
        }}>
        <b>
          Archived Section
        </b>
      </span>
    </Tag>
  )
}